import React, { useState } from "react";
import { useAtom } from "jotai";
import { useNavigate } from "react-router-dom";

import SurveyComponent from "./SurveyForm";
import { activeChildDetail, survey_id } from "../../atomstore/store";
import { useRequestProcessor } from "../../requestProcessor";
import { submitSurvey } from "../../queryfunctions/queryfunctions";
import SpinnerLoading from "./SpinnerLoading";

const Survey = () => {
    const { useMutationWrapper } = useRequestProcessor();
    const navigate = useNavigate();
    const [surveyId, setSurveyId] = useAtom(survey_id)
    const [activeChild] = useAtom(activeChildDetail)

    console.log("surveyid", surveyId);
    const [state, setState] = useState({
        surveyId: surveyId,
        rating: undefined,
        tags: undefined,
        comment: undefined,
        error: undefined,
    });

    const updateFeedback = useMutationWrapper("raiseIssue", () =>
        submitSurvey(state)
    );

    const validate = () => {
        if (state.rating === undefined) {
            setState({ ...state, error: "Please Select Rating" });
            return false;
        }
        return true;
    };

    const submit = () => {
        if (validate()) {
            if (state?.surveyId) {
                updateFeedback.mutate();
            } else {
                setState({ ...state, error: "Survey id missing" });
            }
        }
    };

    const closeSurvey = () => {
        setSurveyId(-1);
        navigate("/home", { replace: true });
    };

    return (
        <div className="fixed inset-0 z-30">
            {updateFeedback?.isLoading && <SpinnerLoading />}

            <div className="fixed inset-0 bg-black/45 backdrop-blur-[2px]"></div>

            <div className="relative z-40 flex min-h-dvh items-center justify-center px-5 py-4">
                <div className="flex w-full max-w-[430px] md:max-w-3xl max-h-[calc(100dvh-32px)] flex-col rounded-2xl bg-white shadow-2xl">
                    {/* Fixed header */}
                    <div className="shrink-0 bg-gradient-to-r from-cyan-600 to-cyan-500 px-7 py-5 text-xl font-bold text-white rounded-t-2xl">
                        Survey
                    </div>

                    {/* Scrollable content */}
                    <div className="flex-1 overflow-y-auto [scrollbar-width:none] [-ms-overflow-style:none] [&::-webkit-scrollbar]:hidden">
                        <SurveyComponent
                            key={surveyId}
                            onRatingPressed={(rating) =>
                                setState({ ...state, rating, error: undefined })
                            }
                            getComment={(comment) =>
                                setState({ ...state, comment, error: undefined })
                            }
                            getTags={(tags) =>
                                setState({ ...state, tags, error: undefined })
                            }
                            selectedChild={activeChild}
                        />

                        <div className="px-7 pb-5">
                            {state.error && (
                                <p className="mb-3 text-sm font-semibold text-red-500">{state.error}</p>
                            )}

                            <button
                                type="button"
                                className="w-full rounded-2xl bg-gradient-to-r from-cyan-600 to-cyan-500 py-4 text-xl font-bold text-white shadow-lg shadow-cyan-600/20 transition hover:from-cyan-700 hover:to-cyan-600"
                                onClick={submit}
                            >
                                Submit Feedback
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Survey;
